import React, { useState } from 'react'
import { Tab, Tabs } from 'react-bootstrap'
import { Box, CssBaseline, useTheme } from '@mui/material';
import MonthlySumPlant1Log from './MonthlySumPlant1Log/MonthlySumPlant1Log';
import MonthlySumPlant1Curve from './MonthlySumPlant1Curve/MonthlySumPlant1Curve';

function MonthlySumPlant1({SUB_PLANT}) {
    const [key, setKey] = useState('Energy Log'); // Set default key to "Energy Log"
    const { spacing } = useTheme()
    return (
        <>
            <CssBaseline />
            <Box sx={{ bgcolor: 'background.default', py: spacing(1) }}>
                <Tabs
                    style={{ justifyContent: "flex-start", }}
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                >
                    <Tab eventKey="Energy Log" title="Energy Log">
                    <MonthlySumPlant1Log SUB_PLANT={SUB_PLANT}/>
                    </Tab>

                    <Tab eventKey="Energy Curve" title="Energy Curve">
                        <MonthlySumPlant1Curve  SUB_PLANT={SUB_PLANT}/>
                    </Tab>
                    
                </Tabs>
            </Box>
        </>
    )
}

export default MonthlySumPlant1;
